import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { playHoverSound, playSelectBattleClickSound } from 'state/actions/sounds'

import styles from './WizardButton.scss'

export const WizardButton = (props) => {
    const cellIconClass = classNames(styles.cell, styles.cell__icon)
    const cellContentClass = classNames(styles.cell, styles.cell__content)
    const cellRewardClass = classNames(styles.cell, styles.cell__reward)

    const className = classNames(styles.base, {
        [styles.base__bonus]: props.bonus,
        [styles.base__battle]: props.battle,
        [styles.base__selected]: props.isSelected,
    })

    const tooltipProps = (props.tooltipId) ? {
        'data-tip': true,
        'data-for': props.tooltipId,
    } : null

    const handleMouseDown = () => props.playSelectBattleClickSound()
    const handleHover = () => props.playHoverSound()

    return (
        <div
            className={className}
            onClick={props.handleClick}
            onMouseDown={handleMouseDown}
            onMouseEnter={handleHover}
            {...tooltipProps}
        >
            <div className={styles.border}>
                <div className={styles.body}>
                    <div className={styles.holder}>
                        <div className={cellIconClass}>
                            {props.iconComponent}
                        </div>
                        <div className={cellContentClass}>
                            <div className={styles.content}>
                                {props.contentComponent}
                            </div>
                        </div>
                        <div className={cellRewardClass}>
                            <div className={styles.reward}>
                                <div className={styles.industrialResource}>
                                    {props.rewardComponent}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

WizardButton.propTypes = {
    handleClick: PropTypes.func,
    playHoverSound: PropTypes.func.isRequired,
    playSelectBattleClickSound: PropTypes.func.isRequired,
    iconComponent: PropTypes.element.isRequired,
    contentComponent: PropTypes.element.isRequired,
    rewardComponent: PropTypes.element.isRequired,
    bonus: PropTypes.bool,
    battle: PropTypes.bool,
    isSelected: PropTypes.bool,
    tooltipId: PropTypes.string,
}
const mapDispatchToProps = { playHoverSound, playSelectBattleClickSound }
export default connect(null, mapDispatchToProps)(WizardButton)



// WEBPACK FOOTER //
// ./components/BattleWizard/components/WizardButton/WizardButton.jsx